import './utskiftning.css'

import React, { Component } from 'react'
import _ from 'lodash'

import { resolve } from '../dependencies'
import Repository from '../felles/repository'
import ArbeidsListeItem from './arbeidsliste-item'
import {Arbeidslistestatus} from '../felles/utils/statuskoder'

export default class Utskiftning extends Component {

  constructor(props) {
    super(props)

    this.state = { 
      arbeidslister: []      
    }
    this._oppdaterListe = this._oppdaterListe.bind(this)
  }
  
  componentDidMount() {
    this.setState({
      laster: true
    })
    
    if(this.props.forside)
      resolve(Repository).hentArbeidslisterForBruker().then(liste => this._oppdaterListe(liste))    
    else
      resolve(Repository).hentArbeidslister().then(liste => this._oppdaterListe(liste))    
  }

  _oppdaterListe(liste){
    this.setState({
      arbeidslister: _.filter(liste, t => t.Status === Arbeidslistestatus.Aktivert)      
    })

    if(this.props.forside){
      this.props.oppdaterForside()
    }
  }

  render() {
    let arbeidsListeAktiv = this.state.arbeidslister.map(liste => <ArbeidsListeItem forside={this.props.forside} liste={liste} key={liste.Id} />);
    let forside = <div className="list-group"> {arbeidsListeAktiv}  </div> 
    let forUtfoering = <div className="listeContainer">  <h2>Utskiftning</h2> <div className="list-group">{arbeidsListeAktiv}</div>             </div>
    
    return (
          this.props.forside ? forside :  forUtfoering        
    )
  }
}

      



// WEBPACK FOOTER //
// ./src/utskiftning/utskiftningContainer.jsx